import React, { Fragment } from 'react'
import useSWR from 'swr'
import {filterValues} from 'Helper'
import Input from 'components/Input'
import MultiSelect from 'components/MultiSelect'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function CreateSchedule({ t }) {
  const {data: time} = useSWR('promos/time')
  const {data: days} = useSWR('promos/days')

  const fields = [
    {
      name: 'from',
      label: t('promo.schedules.form.start'),
      options: time?.data ? filterValues({options: time?.data, param: {label: 'name_12', value: 'id'}, unifier: "(,)", text: 'name_24'}) : []
    },
    {
      name: 'to',
      label: t('promo.schedules.form.end'),
      options: time?.data ? filterValues({options: time?.data, param: {label: 'name_12', value: 'id', unifier: "(,)", text: 'name_24'}}) : []
    },
    {
      name: 'promo_day_id',
      label: t('promo.schedules.form.days'),
      options: days?.data ? filterValues({options: days?.data, param: {label: 'description', value: 'id'}}) : []
    },
  ]
  return (
    <>
      {
        fields.map(({name, label, options}, index) => {
          return (
            <Fragment key={`${name}_${index}`}>
              {
                name !== 'days' ? (
                  <div className="mb-3">
                    <Input 
                      name={name}
                      label={label}
                      options={options}
                    />
                  </div>
                ) : (
                  <MultiSelect 
                    name={name}
                    label={label}
                    options={options}
                    variant="filled"
                  />
                )
              }
            </Fragment>
          )
        })
      }
    </>
  )
})
